import { render, staticRenderFns } from "./HouseLanding.vue?vue&type=template&id=27c60186&"
import script from "./HouseLanding.vue?vue&type=script&lang=js&"
export * from "./HouseLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports